import React, { Component } from "react";
import CssClasses from "./AdminLogin.css";
import RegularKeyboard, {
  KEYBOARD_POSITION_FOR_ADMIN_LOGIN
} from "../Keyboards/RegularKeyboard/RegularKeyboard";
import { connect } from "react-redux";
import * as StoreActions from "../../ReduxStore/Actions/ActionIndex";

import { LoginUserByUsernamePassword } from "../../Communication/OtherServicesHandler";
import FullscreenModalPopup from "../../Components/UI/FullscreenModalPopup/FullscreenModalPopup";

class AdminLogin extends Component {
  K_TEXTBOX_USERNAME = 1;
  K_TEXTBOX_PASSWORD = 2;

  state = {
    currentTextboxID: 0,
    showsRegularKeyboard: false,
    valTxtUsername: "",
    valTxtPassword: "",
    infoMessage: ""
  };

  render() {
    return (
      <div className={CssClasses.container}>
        <div className={CssClasses.popupBox}>
          <div className={[CssClasses.row, CssClasses.titleRow].join(" ")}>
            PRIJAVA ADMINA
          </div>
          <div className={CssClasses.row}>Korisničko ime:</div>
          <div className={CssClasses.row}>
            <input
              type="text"
              className={[
                CssClasses.textBox,
                this.state.currentTextboxID === this.K_TEXTBOX_USERNAME
                  ? CssClasses.txtActive
                  : ""
              ].join(" ")}
              onClick={() => {
                this.txtBox_Enter(this.K_TEXTBOX_USERNAME);
              }}
              value={this.state.valTxtUsername}
            />
          </div>
          <div className={CssClasses.row}>Lozinka:</div>
          <div className={CssClasses.row}>
            <input
              type="password"
              className={[
                CssClasses.textBox,
                this.state.currentTextboxID === this.K_TEXTBOX_PASSWORD
                  ? CssClasses.txtActive
                  : ""
              ].join(" ")}
              onClick={() => {
                this.txtBox_Enter(this.K_TEXTBOX_PASSWORD);
              }}
              value={this.state.valTxtPassword}
            />
          </div>
          <div className={[CssClasses.row, CssClasses.forSubmitBtn].join(" ")}>
            <div
              className={CssClasses.btnSubmit}
              onClick={() => {
                this.btnLogin_Click();
              }}
            >
              PRIJAVI SE
            </div>
          </div>

          <div
            className={CssClasses.btn}
            onClick={() => {
              this.closeTheModal();
            }}
          >
            X
          </div>
        </div>

        <FullscreenModalPopup
          message={this.state.infoMessage}
          btnOkClickCallback={this.modalPopupBtnOk_Callback}
        />

        {this.state.showsRegularKeyboard ? (
          <RegularKeyboard
            closeHandler={() => {
              this.onCloseRegularKeyboard();
            }}
            keyDownHandler={(keyData, isShifted) => {
              this.regularKeyboard_KeyDown(keyData, isShifted);
            }}
            position={KEYBOARD_POSITION_FOR_ADMIN_LOGIN}
          />
        ) : null}
      </div>
    );
  }

  closeTheModal = () => {
    this.setState(
      {
        infoMessage: "",
        showsRegularKeyboard: false,
        valTxtPassword: "",
        valTxtUsername: "",
        currentTextboxID: 0
      },
      () => {
        console.log("State updated...");
        this.props.btnCloseClickCallback();
      }
    );
  };

  txtBox_Enter = txtBoxID => {
    //spremi state
    //pali tipkovnicu
    this.setState({ currentTextboxID: txtBoxID, showsRegularKeyboard: true });
  };

  btnLogin_Click = () => {
    this.setState({ currentTextboxID: 0, showsRegularKeyboard: false });

    this.props.startLoading(false, true);

    //zovi servis
    LoginUserByUsernamePassword(
      this.props.machineInfo.MachineGUID,
      this.state.valTxtUsername,
      this.state.valTxtPassword,
      this.loginUserByUsernamePassword_Callback.bind(this)
    );
  };

  loginUserByUsernamePassword_Callback = val => {
    this.props.stopLoading(true);

    if (!val || val === "") {
      //nema, krivo!
      this.setState({
        infoMessage:
          "Unijeli ste neispravnu kombinaciju korisničkog imena i lozinke!"
      });
      return;
    }
    console.log("USERIC JE ", val);

    //zbog buga prvo zatvori modal a onda salji aadmin info

    //gasi sebi podatke unesene
    //pozovi zatvaranje sebe
    this.closeTheModal();

    //spremi u state podatke o useru
    window.cefCustomObject.changeAdminLoginState(true);
    this.props.setAdminInfo(val);
  };

  modalPopupBtnOk_Callback = () => {
    this.setState({ infoMessage: null });
  };

  regularKeyboard_KeyDown = (keyData, isShifted) => {
    console.log("KEY DATA ", keyData);
    console.log("SHIFTED ", isShifted);

    let oldVal = "";

    if (keyData.value === "shift") {
      return;
    }

    switch (this.state.currentTextboxID) {
      case this.K_TEXTBOX_USERNAME:
        oldVal = this.state.valTxtUsername + "";
        break;
      case this.K_TEXTBOX_PASSWORD:
        oldVal = this.state.valTxtPassword + "";
        break;
      default:
        break;
    }

    if (keyData.value === "bksp") {
      //rezi ako je duzi od 0
      if (oldVal.length > 0) {
        oldVal = oldVal.slice(0, -1);
      }
    } else {
      oldVal = oldVal + (isShifted ? keyData.labelShifted : keyData.label);
    }

    //i vrati u state
    switch (this.state.currentTextboxID) {
      case this.K_TEXTBOX_USERNAME:
        this.setState({ valTxtUsername: oldVal });
        break;
      case this.K_TEXTBOX_PASSWORD:
        this.setState({ valTxtPassword: oldVal });
        break;
      default:
        break;
    }
  };

  onCloseRegularKeyboard = () => {
    this.setState({ showsRegularKeyboard: false, currentTextboxID: 0 });
  };
}

const mapStateToProps = state => {
  return {
    machineInfo: state.rrAppState.machineInfo
  };
};

const mapDispatchToProps = dispatch => {
  return {
    startLoading: (isTransparent, updateLocalStorage) =>
      dispatch(StoreActions.StartLoading(isTransparent, updateLocalStorage)),
    stopLoading: updateLocalStorage =>
      dispatch(StoreActions.StopLoading(updateLocalStorage)),
    setAdminInfo: userInfo => dispatch(StoreActions.SetAdminInfo(userInfo))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminLogin);



// WEBPACK FOOTER //
// ./src/Components/AdminLogin/AdminLogin.js